import React from 'react';
import { PageLayout } from '../components';
import {
  HeroSection,
  HelpersSection,
  FeaturesSection,
  TestimonialsSection,
  CTASection,
  ContactSection
} from '@/components/sections';
const PublicHomePage: React.FC = () => {
  return (
    <PageLayout contentPadding="none">
      <HeroSection />
      <HelpersSection />
      <FeaturesSection />
      <TestimonialsSection />
      <CTASection />
      <ContactSection />
    </PageLayout>
  );
};

export default PublicHomePage;
